var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-grid"},[_c('transition-group',{attrs:{"mode":"out-in","tag":"div","name":"fade"}},[(_vm.status === 'loading')?_c('Spinner',{key:"spinner"}):_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }